// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"86dce415","880":"3f80605d"}[chunkId] + ".chunk.css";
};